'use client'

import { DotLottiePlayer } from '@dotlottie/react-player'

export type AirplaneLoadingSpinnerProps = {
  className?: string
}

export function AirplaneLoadingSpinner({ className }: AirplaneLoadingSpinnerProps) {
  return (
    <div className={className}>
      <DotLottiePlayer src="/assets/lottie/airplane-spinner.json" autoplay loop />
    </div>
  )
}
